var _path, _path2, _path3, _ellipse, _path4, _ellipse2, _ellipse3, _path5, _ellipse4, _ellipse5;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPlayDoh = function SvgPlayDoh(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 600",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M527.67 120.23c-2.47 0-24.8-.83-24.8-26.87a2.69 2.69 0 1 0-5.37 0c0 26-22.33 26.87-24.81 26.87h-.21a2.7 2.7 0 0 0-2.48 2.69 2.74 2.74 0 0 0 2.69 2.68c2.69 0 24.81.83 24.81 26.88a2.74 2.74 0 0 0 2.68 2.69 2.39 2.39 0 0 0 2.48-2.49c0-26 22.33-26.87 24.81-26.87h.2a2.78 2.78 0 0 0 2.69-2.89 2.74 2.74 0 0 0-2.69-2.69z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M307.5 480.45h69.38c18.91 0 34.6-15.94 35.91-36.49l11.67-182.55h-117z",
    fill: "#f4abe0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M318.21 480.45h-69.38c-18.92 0-34.6-15.94-35.92-36.49l-11.66-182.55h117z",
    fill: "#fdb73e"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 313.74,
    cy: 235.58,
    rx: 125.87,
    ry: 51.49,
    fill: "#ef6ba0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ef6ba0",
    d: "M188.69 201.75h249.92v33.92H188.69z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 272.91,
    cy: 385.06,
    rx: 37.19,
    ry: 29.83,
    fill: "#ef6ba0"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 350.03,
    cy: 385.06,
    rx: 37.19,
    ry: 29.83,
    fill: "#ef6ba0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe4476",
    d: "M272.69 374.03h76.83v40.87h-76.83z"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 308.7,
    cy: 371.99,
    rx: 47.81,
    ry: 42.5,
    fill: "#ef6ba0"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 313.74,
    cy: 201.75,
    rx: 125.87,
    ry: 51.49,
    fill: "#f0592b"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlayDoh, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/play_doh.d0c6c79f.svg";
export { ForwardRef as ReactComponent };